import InternalStaticAnchorRewardCafeteria from 'models/application/anchor/types/internalStatic/types/RewardCafeteria';

export default class InternalStaticAnchorRewardCafeteriaService {
	toModel(anchor) {
		return new InternalStaticAnchorRewardCafeteria(anchor);
	}
}
